import { Confianca } from "./style";


function ConfiancaComponent(params) {
    return (
        <Confianca>
            <h1>O que é o Processo Comportamental?</h1>
            <iframe
                src="https://www.youtube.com/embed/Jb1TBG5AMKM"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                title="Vídeo explicativo sobre o curso"
            />

        </Confianca>
    )
}

export default ConfiancaComponent